import ScreensaverLayout from '../../components/pages/Screensaver';
import themes from '../../themes';

export default function Screensaver() {
  return <ScreensaverLayout station={'tragen'} theme={themes.tragen} />;
}
